import { PlusIcon } from '@phosphor-icons/react';
import { css, html } from 'react-strict-dom';
import { Api } from 'src/api';
import { Dropdown, IconButton, Stack, Text, TimerButton } from 'src/components';
import { Color, Style } from 'src/constants';
import { color } from 'src/constants/color.css';
import { useTimerChange } from 'src/contexts';
import { Model } from 'src/models';
import { formatTimeSpent } from 'src/util';

import WorkDoneDropdown from './WorkDoneDropdown';

type Props = {
  ticket: Api.Ticket.V_Detail;
  company: Api.Company.BaseView;
  invalidate: () => void;
};

export default function TimeTrackingCard({
  ticket,
  company,
  invalidate,
}: Props) {
  const totalMinutes = Model.WorkDone.sumMinutes(ticket.workDones);

  // The total only moves once a stretch has been stopped and banked.
  useTimerChange(invalidate);

  return (
    <html.div style={styles.card}>
      <html.div style={[Style.row, Style.alignCenter, Style.spaceBetween]}>
        <Stack gap={0.5}>
          <Text typeface="body.regular" color="neutral80">
            Time Tracking
          </Text>
          <Text typeface="body.medium" color="neutral100">
            {formatTimeSpent(totalMinutes) ?? '0m'}
          </Text>
        </Stack>
        <html.div style={[Style.row, Style.alignCenter, styles.controls]}>
          {/* The clock rides on the button, since the total beside it only
              moves once the timer has been stopped and banked. */}
          <TimerButton
            target={Model.TimerTarget.fromTicket(ticket, company)}
            showLabel
          />
          <Dropdown
            trigger={
              <IconButton>
                <PlusIcon size={20} color={Color.neutral80} />
              </IconButton>
            }
            anchorSide="right"
          >
            <WorkDoneDropdown
              defaultValues={{ ticket: `/tickets/${ticket.id}` }}
              workDones={Model.WorkDone.filterLogged(ticket.workDones)}
              invalidate={invalidate}
            />
          </Dropdown>
        </html.div>
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  card: {
    backgroundColor: color.neutral10,
    borderRadius: 12,
    padding: 16,
  },
  controls: {
    gap: 8,
  },
});
